/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Surface visibility determines whether it shows DevourPlay navigation or is a standalone landing page
 * @export
 */
export const SurfaceVisibility = {
    PUBLIC: 'PUBLIC',
    PRIVATE: 'PRIVATE'
} as const;
export type SurfaceVisibility = typeof SurfaceVisibility[keyof typeof SurfaceVisibility];


export function instanceOfSurfaceVisibility(value: any): boolean {
    for (const key in SurfaceVisibility) {
        if (Object.prototype.hasOwnProperty.call(SurfaceVisibility, key)) {
            if (SurfaceVisibility[key as keyof typeof SurfaceVisibility] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SurfaceVisibilityFromJSON(json: any): SurfaceVisibility {
    return SurfaceVisibilityFromJSONTyped(json, false);
}

export function SurfaceVisibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceVisibility {
    return json as SurfaceVisibility;
}

export function SurfaceVisibilityToJSON(value?: SurfaceVisibility | null): any {
    return value as any;
}

export function SurfaceVisibilityToJSONTyped(value: any, ignoreDiscriminator: boolean): SurfaceVisibility {
    return value as SurfaceVisibility;
}

